<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="3"/>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.type" label="Type" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="3"/>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="eid" label="ID" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.core_transaction_id" label="Transaction ID" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.shop_id" label="Shop" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.core_location_id" label="Location ID" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.customer_id" label="Customer ID" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.timestamp" label="Timestamp" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="4">
        <FloatingLabel v-model="details.gross_amount" label="Gross Amount" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="4">
        <FloatingLabel v-model="details.net_amount" label="Net Amount" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="4">
        <FloatingLabel v-model="details.tax_amount" label="Tax Amount" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.status" label="Status code" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.status_text" label="Status description" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.withdrawal_id" label="Withdrawal Reference ID" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="6">
        <FloatingLabel v-model="details.cancel_id" label="ID Canceled" :readonly="true" size="sm"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="3">
        <FloatingLabel v-model="details.canceled" label="Canceled" :readonly="true" size="sm"/>
      </b-col>
      <b-col cols="12" xl="9">
        <b-button
          v-if="details.isCancelable == true"
          variant="primary"
          @click="$bvModal.show('bv-modal-txcancel')"
        >
          {{$t('Cancel transaction')}}
        </b-button>
      </b-col>
    </b-row>
    <b-modal id="bv-modal-txcancel" size="md" scrollable>
      <template slot="modal-title">{{$t('Online Cash Transaction Cancel')}}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <OnlineCashTransactionCancel :eid="eid" />
      <template slot="modal-footer">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('bv-modal-txcancel')"
        >
          {{$t('Cancel')}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import timeFormat from "@/shared/timeFormat";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import OnlineCashTransactionCancel from "./OnlineCashTransactionCancel";

export default {
  name: "onlinecashtransaction",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    OnlineCashTransactionCancel,
  },

  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      return
    }

  },

  data: function() {
    return {
      eid: "",
      eshop_id: "",
      details: {
        type: null,
        shop_id: null,
        core_location_id: null,
        customer_id: null,
        gross_amount: null,
        net_amount: null,
        tax_amount: null,
        core_transaction_id: null,
        withdrawal_id: null,
        timestamp: null,
        status: null,
      },
    };
  },

  watch: {
  },

  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("onlineCashTX/read", this.eid)
        .then(resp => {
          // console.log("Transaction data loaded in modal:", resp.data); // debug only
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },

    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.eshop_id = r.eshop_id;

      this.details.type = "-";
      if (r.type == 1) this.details.type = this.$t("Deposit");
      if (r.type == 2) this.details.type = this.$t("Withdrawal");
      if (r.type == 3) this.details.type = this.$t("Cancellation");
      if (r.type == 23) this.details.type = this.$t("Deposit");
      if (r.type == 24) this.details.type = this.$t("Withdrawal");
      if (r.type == 25) this.details.type = this.$t("Cancellation");

      this.details.core_transaction_id = r.core_transaction_id;
      this.details.core_location_id = r.core_location_id;
      this.details.customer_id = r.customer_id;
      this.details.gross_amount = this.roundThousands(r.gross_amount);
      this.details.net_amount = this.roundThousands(r.net_amount);
      this.details.tax_amount = this.roundThousands(r.tax_amount);
      this.details.timestamp = this.mom_unix(r.timestamp).format(timeFormat.tableDateLong);

      this.details.canceled = r.canceled ? this.$t("Yes") : this.$t("no");
      this.details.status = r.status ? r.status : "-";

      this.details.status_text = "-";
      if (r.status && r.status == 0) this.details.status_text = this.$t("OK");
      if (r.status == 1) this.details.status_text = this.$t("Error");
      if (r.status == 2) this.details.status_text = this.$t("Not found");
      if (r.status == 3) this.details.status_text = this.$t("Canceled");
      if (r.status == 4) this.details.status_text = this.$t("Pending");
      if (r.status == 5) this.details.status_text = this.$t("Processed");
      if (r.status == 6) this.details.status_text = this.$t("Rejected");
      if (r.status == 7) this.details.status_text = this.$t("Location mismatch");
      if (r.status == 8) this.details.status_text = this.$t("Reference error");
      if (r.status == 9) this.details.status_text = this.$t("Invalid code");

      this.details.withdrawal_id = r.withdrawal_id ? r.withdrawal_id : "-";
      this.details.cancel_id = r.cancel_id ? r.cancel_id : "-";

      this.details.isCancelable = false;
      if (r.canceled == false && (r.type == 1 || r.type == 23)) this.details.isCancelable = true;

      const shopByID = this.$store.getters["cache/shopByID"];
      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch(e => e)
      ])
        .catch(err => {})
        .finally(() => {
          const data = shopByID(this.eshop_id);
          if (data) {
            this.details.shop_id = data.name
          } else {
            this.details.shop_id = this.eshop_id
          }
          // console.log("Details after populating data:", this.details); // debug only
        });

    },

    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";
      const decimals = 2;
      const tmp = value / 10000;
      const res = Number(
        Math.round(tmp + "e" + decimals) + "e-" + decimals
      ).toFixed(decimals);
      return res.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },

    mom_unix(val) {
      if (!val)
        return {
          format() {
            return "";
          }
        };
      return moment.unix(val / 1e9);
    },

    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },

  },

};
</script>

<style lang="scss" scoped>
</style>
